<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <section class="basic-elements">
              <div class="row">
                <div class="col-md-12">
                  <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                  <h2 class="content-header">{{ $t("labels.homeInformation")  }}</h2>
                </div>
              </div>
              <div class="card">
                <div class="card-body" v-html="text">
                </div>
              </div>
            </section>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marked from 'marked'
marked.setOptions({
  breaks: true
})
export default {
  data: function() {
    return {
      text_it: `
Dravet Diary è un diario elettronico prodotto per le persone affette da epilessia ed in particolare per la forma rara e complessa “Sindrome di Dravet”.

Dravet Diary ha lo scopo di documentare con cura le crisi, lo stato di salute e la terapia in corso e di predisporre tali informazioni facilmente inviabili ai propri specialisti che possono così essere aggiornati sull’andamento della patologia.
Uno strumento efficace, dedicato alle famiglie impegnate nell’assistenza dei propri bambini, ragazzi ed adulti, per cercare di migliorare la gestione della patologia nel suo complesso e al contempo fornire ai medici dati precisi e aggiornati.

Dravet Diary è disponibile gratuitamente, in diverse lingue, sull’AppStore, su Google Store e sul sito www.dravetdiary.com.

Con lo stesso account si potrà accedere da più dispositivi, in modo da poter aggiornare le informazioni in modo semplice e veloce!

Permette di tenere sotto controllo tutta la gestione dei fattori più importanti, come le diverse variabili direttamente collegate alla patologia, oltre ai farmaci e alle crisi 
e i possibili effetti collaterali, il rischio aggiuntivo di altre patologie intercorrenti ed eventualmente i video delle crisi.

Dravet Diary ha esteso il suo uso, alla vita quotidiana, con la possibilità di usare l’applicazione per appuntarsi visite mediche, l’archivio dei referti e attività varie, nonché caricare file pdf di rilevanza per il paziente.

Ha inoltre una sezione “Emergenza” con il protocollo di emergenza, i contatti e con la possibilità di fare l’eventuale chiamata direttamente dall’app. 
      `,
      text_en: `
Dravet Diary is an electronic diary produced for people with epilepsy and in particular for the rare and complex form of “Dravet Syndrome”.

Dravet Diary has the purpose of carefully documenting the crises, the state of health and the therapy in progress and to prepare such information that can be easily sent to its specialists who can thus be updated on the progress of the disease.
An effective tool, dedicated to families involved in the care of their children, teens and adults, to try to improve the management of the disease as a whole and at the same time provide doctors with accurate and updated data.

Dravet Diary is available free of charge, in several languages, on the AppStore, on the Google Store and on the website www.dravetdiary.com.

With the same account you can log in from multiple devices, so you can update information quickly and easily!

It allows you to keep under control all the management of the most important factors, such as the various variables directly linked to the disease, in addition to drugs and crises
and possible side effects, the additional risk of other intercurrent pathologies and possibly seizure videos.

Dravet Diary has extended its use to daily life, with the possibility of using the application to record medical examinations, the archive of reports and various activities, as well as uploading pdf files of relevance to the patient.

It also has an "Emergency" section with the emergency protocol, contacts and the ability to make any call directly from the app.
      `,
      text_nl: `
  Dravet Diary is een elektronisch dagboek voor mensen met epilepsie en in het bijzonder de zeldzame en complexe vorm 'Dravet Syndroom'.
 
 Het doel van Dravet Diary is om aanvallen, de gezondheidstoestand en de lopende therapie zorgvuldig te documenteren en deze informatie klaar te maken voor gemakkelijke verzending naar specialisten die dan op de hoogte kunnen blijven van de voortgang van de aandoening.
 Een effectief hulpmiddel voor gezinnen die betrokken zijn bij de zorg voor hun kinderen, tieners en volwassenen, om te proberen het beheer van de ziekte als geheel te verbeteren en tegelijkertijd artsen te voorzien van nauwkeurige en actuele gegevens.
 
 Dravet Diary is gratis beschikbaar, in verschillende talen, in de AppStore, Google Store en www.dravetdiary.com.
 Hetzelfde account is toegankelijk vanaf meerdere apparaten, dus je kunt informatie snel en gemakkelijk bijwerken!
 
 Hiermee kun je alle belangrijke factoren bijhouden, zoals de verschillende variabelen die direct verband houden met de ziekte, maar ook medicatie en aanvallen 
 en mogelijke bijwerkingen, het extra risico van andere intercurrente ziekten en, indien nodig, aanvalsvideo's.
 
 Dravet Diary heeft het gebruik uitgebreid naar het dagelijks leven, met de mogelijkheid om de applicatie te gebruiken voor het noteren van doktersbezoeken, het archiveren van rapporten en verschillende activiteiten, evenals het uploaden van pdf-bestanden die relevant zijn voor de patiënt.
 
 Er is ook een sectie 'Noodgevallen' met het noodprotocol, contactpersonen en de mogelijkheid om direct vanuit de app te bellen.
      `,
      text_de: `
Dravet Diary ist ein elektronisches Tagebuch für Menschen mit Epilepsie und insbesondere mit der seltenen und komplexen Form des Dravet-Syndroms.
 
 Ziel des Dravet Diary ist es, die Anfälle, den Gesundheitszustand und die laufende Therapie sorgfältig zu dokumentieren und diese Informationen so aufzubereiten, dass sie leicht an Spezialisten weitergeleitet werden können, die dann über den Verlauf der Erkrankung auf dem Laufenden gehalten werden können.
 Es ist ein wirksames Instrument für Familien, die sich um ihre Kinder, Jugendlichen und Erwachsenen kümmern, um die Behandlung der Krankheit insgesamt zu verbessern und gleichzeitig den Ärzten genaue und aktuelle Daten zur Verfügung zu stellen.
 
 Dravet Diary ist kostenlos und in mehreren Sprachen im AppStore, Google Store und www.dravetdiary.com erhältlich.
 
 Auf ein und dasselbe Konto kann von mehreren Geräten aus zugegriffen werden, so dass Sie Informationen schnell und einfach aktualisieren können!
 
 Es ermöglicht Ihnen, alle wichtigen Faktoren im Auge zu behalten, wie die verschiedenen Variablen, die direkt mit der Krankheit zusammenhängen, sowie Medikamente und Anfälle 
 und mögliche Nebenwirkungen, das zusätzliche Risiko anderer interkurrenter Pathologien und, falls erforderlich, Anfallsvideos.
 
 Dravet Diary wurde auf den Alltag ausgeweitet und bietet die Möglichkeit, die Anwendung zu nutzen, um Arztbesuche, das Archiv von Berichten und verschiedene Aktivitäten zu notieren sowie für den Patienten relevante PDF-Dateien hochzuladen.
 
 Außerdem gibt es einen Bereich "Notfall" mit dem Notfallprotokoll, Kontakten und der Möglichkeit, direkt von der App aus einen Anruf zu tätigen
      `,
      text_es: `
Dravet Diary es un diario electrónico elaborado para personas con epilepsia y, en particular, con la forma rara y compleja "Síndrome de Dravet".
 
 El objetivo de Dravet Diary es documentar minuciosamente las crisis, el estado de salud y la terapia actual, y preparar esta información para transmitirla fácilmente a los especialistas, que pueden así estar al corriente de la evolución de la enfermedad.
 Una herramienta eficaz, dedicada a las familias implicadas en el cuidado de sus hijos, adolescentes y adultos, para intentar mejorar la gestión de la enfermedad en su conjunto y, al mismo tiempo, proporcionar a los médicos datos precisos y actualizados.
 
 Dravet Diary está disponible gratuitamente, en varios idiomas, en AppStore, Google Store y www.dravetdiary.com.
 
 Se puede acceder a la misma cuenta desde varios dispositivos, por lo que puede actualizar la información de forma rápida y sencilla.
 
 Permite realizar un seguimiento de todos los factores más importantes, como las distintas variables directamente relacionadas con la enfermedad, así como la medicación y las convulsiones 
 y los posibles efectos secundarios, el riesgo adicional de otras patologías intercurrentes y, en caso necesario, los vídeos de las crisis.
 
 Dravet Diary ha extendido su uso a la vida cotidiana, con la posibilidad de utilizar la aplicación para anotar las visitas al médico, el archivo de informes y actividades diversas, así como subir archivos pdf de relevancia para el paciente.
 
 También cuenta con una sección de "Emergencias" con el protocolo de emergencias, contactos y la posibilidad de realizar una llamada directamente desde la app.
      `,
      text_fr: `
  Le Journal de Dravet est un journal électronique destiné aux personnes atteintes d'épilepsie, et plus particulièrement de la forme rare et complexe qu'est le "syndrome de Dravet".
 
 L'objectif de Dravet Diary est de documenter soigneusement les crises, l'état de santé et les thérapies en cours, et de préparer ces informations pour les transmettre facilement aux spécialistes qui peuvent ainsi être tenus au courant de l'évolution de la maladie.
 Un outil efficace, dédié aux familles impliquées dans la prise en charge de leurs enfants, adolescents et adultes, pour tenter d'améliorer la gestion de la maladie dans son ensemble et en même temps fournir aux médecins des données précises et actualisées.
 
 Dravet Diary est disponible gratuitement, en plusieurs langues, sur l'AppStore, Google Store et www.dravetdiary.com.
 
 Le même compte est accessible à partir de plusieurs appareils, ce qui permet de mettre à jour les informations rapidement et facilement !
 
 Il vous permet de suivre tous les facteurs les plus importants, tels que les différentes variables directement liées à la maladie, ainsi que les médicaments et les crises d'épilepsie. 
 et les effets secondaires possibles, le risque supplémentaire d'autres pathologies intercurrentes et, si nécessaire, les vidéos de crises.
 
 Dravet Diary a étendu son utilisation à la vie quotidienne, avec la possibilité d'utiliser l'application pour noter les visites chez le médecin, l'archivage des rapports et diverses activités, ainsi que le téléchargement de fichiers pdf pertinents pour le patient.
 
 L'application comporte également une section "Urgences" avec le protocole d'urgence, les contacts et la possibilité de passer un appel directement à partir de l'application.
      `,
      text_cr: `
Dravet Diary je elektronički dnevnik proizveden za osobe oboljele od epilepsije osobito za oboljele od rijetkog i kompleksnog sindroma Dravet. 
Svrha Dravet Diary-a je pažljivo dokumentiranje epileptičkih napadaja, zdravstvenih stanja i korištene terapije kao i pripremanje ovih informacija u oblik koji se lako može prenijeti liječnicima kako bi bili obaviješteni o napretku bolesti. 
Ovaj učinkovit alat, namijenjen obiteljima koje skrbe za svoju djecu, adolescente i odrasle oboljele, nastoji poboljšati liječenje i nadziranje bolesti i istovremeno pružati liječnicima točne i ažurirane podatke. 
Aplikacija Dravet Diary je besplatna i dostupna na nekoliko jezika te na AppStore, Google Store i web stranici [www.dravetdiary.com].
S istim računom možete se prijaviti s više uređaja i tako brže i lakše ažurirati informacije!
Omogućuje vam da održavate kontrolu nad upravljanjem svih važnih čimbenika poput različitih varijabli koje su izravno povezane s bolešću kao što su lijekovi, epileptički napadaji, moguće nuspojave, dodatan rizik drugih patologija i dodavanje videozapisa epileptičkih napadaja. 
Dravet Diary je proširio svoju upotrebu na svakodnevni život s mogućnošću korištenja aplikacije za dokumentiranje medicinske dokumentacije, arhiviranja medicinske dokumentacije i aktivnosti kao i za učitavanje pdf dokumenata koji su relevantni za oboljelog. 
Također ima i odjeljak za “Hitna stanja” s protokolom za hitna stanja, kontaktima i mogućnošću pozivanja izravno putem aplikacije."
      `
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'home'})
    },
  },
  computed: {
    text: function() {
      let locale = this.$i18n.locale
      if (locale == 'en' || locale == 'it' || locale == 'nl' || locale == 'de' || locale == 'es' || locale == 'fr' || locale == 'cr'){
        return marked(this['text_'+this.$i18n.locale]);
      }else {
        return marked(this['text_en']);
        
      }
    }
  }
}
</script>